// cspell:disable

import type { CountryCode as Code } from "./country-codes";
import { countryCodes, territoryCodeToCountryMap } from "./country-codes";

export type CountryCode = Code;

// The canonical code list lives in ./country-codes so size-limited bundles
// (Shopify extensions) can use codes without pulling in the ~31KB of names.
const countryNameByCode = {
  US: "United States",
  UM: "United States Minor Outlying Islands",
  CA: "Canada",
  AF: "Afghanistan",
  AX: "Åland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, The Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic Of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People'S Republic of",
  KR: "South Korea",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People'S Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, The Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "RWANDA",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  BL: "Saint Barthélemy",
  BQ: "Bonaire, Sint Eustatius and Saba",
  CW: "Curaçao",
  ME: "Montenegro",
  MF: "Saint Martin",
  RS: "Serbia",
  SS: "South Sudan",
  SX: "Sint Maarten",
} as const satisfies Record<CountryCode, string>;

export type CountryName = (typeof countryNameByCode)[CountryCode];

export const countries: readonly { name: CountryName; code: CountryCode }[] =
  countryCodes.map((code) => ({ name: countryNameByCode[code], code }));

export interface Country {
  code: CountryCode;
  name: CountryName;
}

export const COUNTRIES_BY_CODE = Object.fromEntries(
  countries.map((country) => [country.code, country.name]),
);

export const COUNTRIES_BY_NAME = Object.fromEntries(
  countries.map((country) => [country.name, country.code]),
);

/** Informal GB spellings that are not ISO 3166-1 alpha-2 codes. */
export const GB_COUNTRY_ALIASES: ReadonlySet<string> = new Set([
  "UK",
  "GREAT BRITAIN",
]);

/** Informal US spellings that are not ISO 3166-1 alpha-2 codes. */
export const US_COUNTRY_ALIASES: ReadonlySet<string> = new Set([
  "USA",
  "U S A",
  "UNITED STATES OF AMERICA",
]);

export function findCountryCode(
  country: string,
  resetTerritoryCodeToCountryCode?: boolean,
): CountryCode | undefined {
  if (!country) {
    return undefined;
  }
  let code: CountryCode | undefined;
  if (COUNTRIES_BY_CODE[country.toUpperCase()]) {
    code = country.toUpperCase() as CountryCode;
  } else {
    code = countries.find(
      (c) => c.name.toLowerCase() === country.toLowerCase(),
    )?.code;
  }

  if (
    code &&
    resetTerritoryCodeToCountryCode &&
    territoryCodeToCountryMap.has(code)
  ) {
    return territoryCodeToCountryMap.get(code) ?? code;
  }

  return code;
}

/** Free-form address country to ISO alpha-2. Use this for merchant- or
 * carrier-supplied text; findCountryCode is the plain ISO-table lookup. */
export function toIsoAlpha2(
  country: string | undefined | null,
): string | undefined {
  const trimmed = country?.trim();
  if (!trimmed) {
    return undefined;
  }
  const upper = trimmed.toUpperCase();
  if (GB_COUNTRY_ALIASES.has(upper)) {
    return "GB";
  }
  if (US_COUNTRY_ALIASES.has(upper)) {
    return "US";
  }
  return findCountryCode(trimmed) ?? undefined;
}

export function findCountryName(code: string): CountryName | undefined {
  if (!code) {
    return undefined;
  }
  if (COUNTRIES_BY_NAME[code.toUpperCase()]) {
    return code.toUpperCase() as CountryName;
  }
  return countries.find((c) => c.code.toLowerCase() === code.toLowerCase())
    ?.name;
}

/**
 * Whether a country matches a user search query, by display name or by code
 * (e.g. "united" and "us" both match the US). The canonical matcher for any
 * country picker UI — mirrors `localeMatchesSearch` in `@redotech/redo-i18n`.
 *
 * `displayName` defaults to the ISO country name; pass an override (e.g. a
 * Shopify market label) to match on the name actually shown to the user.
 */
export function countryMatchesSearch(
  code: string,
  query: string,
  displayName: string = COUNTRIES_BY_CODE[code.toUpperCase()] ?? code,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) {
    return true;
  }
  return (
    displayName.toLowerCase().includes(q) || code.toLowerCase().includes(q)
  );
}

// Countries without postal/ZIP codes. Sourced from Shopify's checkout
// requirements. "XZ" represents international waters.
export const POSTAL_CODE_OPTIONAL_COUNTRIES: ReadonlySet<string> = new Set([
  "AE",
  "AG",
  "AO",
  "AQ",
  "AW",
  "BI",
  "BJ",
  "BO",
  "BS",
  "BV",
  "BW",
  "BZ",
  "CF",
  "CG",
  "CI",
  "CK",
  "CM",
  "CW",
  "DJ",
  "DM",
  "EG",
  "ER",
  "ET",
  "FJ",
  "GA",
  "GD",
  "GM",
  "GN",
  "GQ",
  "GW",
  "GY",
  "HK",
  "JM",
  "KM",
  "KP",
  "LY",
  "MO",
  "MR",
  "QA",
  "RW",
  "SB",
  "SC",
  "SD",
  "SL",
  "SO",
  "SR",
  "SS",
  "ST",
  "SX",
  "SY",
  "TD",
  "TF",
  "TG",
  "TK",
  "TL",
  "TO",
  "TV",
  "VU",
  "XZ",
  "YE",
  "ZM",
  "ZW",
]);

export function isPostalCodeRequired(
  country: string | undefined | null,
): boolean {
  if (!country) {
    return true;
  }
  const code = findCountryCode(country) ?? country.toUpperCase();
  return !POSTAL_CODE_OPTIONAL_COUNTRIES.has(code);
}
